interface IEnvironment {
  REACT_APP_ENV: 'local' | 'dev' | 'production';
  REACT_APP_API_URL: string;
  REACT_APP_API_WEBSOCKET_URL: string;
  REACT_APP_COOKIE_API_TOKEN_KEY: string;
  REACT_APP_COOKIE_DOMAIN: string;
  REACT_APP_SUPER_COOKIE_DOMAIN: string;
  REACT_APP_URL: string;
  REACT_APP_KEEPITAL_URL: string;
  REACT_APP_ADMIN_URL: string;
  REACT_APP_SUPER_URL: string;
  REACT_APP_GOOGLE_MAP_API_KEY: string;
  REACT_APP_PAYPAL_CLIENT_ID: string;
}
export default function useEnvironment(): IEnvironment {
  return (process.env as unknown) as IEnvironment;
}
